export const SIGN_IN = 'SIGN_IN'
export const SIGN_IN_FULFILLED = 'SIGN_IN_FULFILLED'
export const SIGN_IN_REJECTED = 'SIGN_IN_REJECTED'
export const signIn = (payload = {}) => ({type: SIGN_IN, payload})

export const SIGN_IN_GOOGLE = 'SIGN_IN_GOOGLE'
export const SIGN_IN_GOOGLE_FULFILLED = 'SIGN_IN_GOOGLE_FULFILLED'
export const SIGN_IN_GOOGLE_REJECTED = 'SIGN_IN_GOOGLE_REJECTED'
export const signInGoogle = (payload = {}) => ({ type: SIGN_IN_GOOGLE, payload })

export const SIGN_IN_FACEBOOK = 'SIGN_IN_FACEBOOK'
export const SIGN_IN_FACEBOOK_FULFILLED = 'SIGN_IN_FACEBOOK_FULFILLED'
export const SIGN_IN_FACEBOOK_REJECTED = 'SIGN_IN_FACEBOOK_REJECTED'
export const signInFacebook = (payload = {}) => ({ type: SIGN_IN_FACEBOOK, payload })

export const CONFIRM_SIGN_IN = 'CONFIRM_SIGN_IN'
export const CONFIRM_SIGN_IN_FULFILLED = 'CONFIRM_SIGN_IN_FULFILLED'
export const CONFIRM_SIGN_IN_REJECTED = 'CONFIRM_SIGN_IN_REJECTED'
export const confirmSignIn = (payload = {}) => ({type: CONFIRM_SIGN_IN, payload})

export const CONFIRM_PHONE_CODE = 'CONFIRM_PHONE'
export const CONFIRM_PHONE_CODE_FULFILLED = 'CONFIRM_PHONE_CODE_FULFILLED'
export const CONFIRM_PHONE_CODE_REJECTED = 'CONFIRM_PHONE_CODE_REJECTED'
export const confirmPhoneCode = (payload = {}) => ({
  type: CONFIRM_PHONE_CODE,
  payload,
})

export const CUSTOM_EMAIL_VERIFICATION = 'CUSTOM_EMAIL_VERIFICATION'
export const CUSTOM_EMAIL_VERIFICATION_FULFILLED = 'CUSTOM_EMAIL_VERIFICATION_FULFILLED'
export const CUSTOM_EMAIL_VERIFICATION_REJECTED = 'CUSTOM_EMAIL_VERIFICATION_REJECTED'
export const customEmailVerification = (payload = {}) => ({
  type: CUSTOM_EMAIL_VERIFICATION,
  payload,
})

export const CONFIRM_PHONE = 'CONFIRM_PHONE'
export const CONFIRM_PHONE_FULFILLED = 'CONFIRM_PHONE_FULFILLED'
export const CONFIRM_PHONE_REJECTED = 'CONFIRM_PHONE_REJECTED'
export const confirmPhone = (payload = {}) => ({type: CONFIRM_PHONE, payload})

export const COMPLETE_NEW_PASSWORD = 'COMPLETE_NEW_PASSWORD'
export const COMPLETE_NEW_PASSWORD_FULFILLED = 'COMPLETE_NEW_PASSWORD_FULFILLED'
export const COMPLETE_NEW_PASSWORD_REJECTED = 'COMPLETE_NEW_PASSWORD_REJECTED'
export const completeNewPassword = (payload = {}) => ({
  type: COMPLETE_NEW_PASSWORD,
  payload,
})

export const SETUP_ONE_TIME_PASSWORD = 'SETUP_ONE_TIME_PASSWORD'
export const SETUP_ONE_TIME_PASSWORD_FULFILLED = 'SETUP_ONE_TIME_PASSWORD_FULFILLED'
export const SETUP_ONE_TIME_PASSWORD_REJECTED = 'SETUP_ONE_TIME_PASSWORD_REJECTED'
export const setupOneTimePassword = (payload = {}) => ({
  type: SETUP_ONE_TIME_PASSWORD,
  payload,
})

export const SET_LEGACY_SESSION = 'SET_LEGACY_SESSION'
export const SET_LEGACY_SESSION_FULFILLED = 'SET_LEGACY_SESSION_FULFILLED'
export const SET_LEGACY_SESSION_REJECTED = 'SET_LEGACY_SESSION_REJECTED'
export const setLegacySession = (payload = {}) => ({
  type: SET_LEGACY_SESSION,
  payload,
})

export const RESET_PASSWORD_REQUIRED = 'RESET_PASSWORD_REQUIRED'

export const RESET_PASSWORD_NOT_REQUIRED = 'RESET_PASSWORD_NOT_REQUIRED'

export const RESET_PASSWORD = 'RESET_PASSWORD'
export const RESET_PASSWORD_FULFILLED = 'RESET_PASSWORD_FULFILLED'
export const RESET_PASSWORD_REJECTED = 'RESET_PASSWORD_REJECTED'
export const resetPassword = (payload = {}) => ({type: RESET_PASSWORD, payload})

export const RESET_PASSWORD_BY_EMAIL = 'RESET_PASSWORD_BY_EMAIL'
export const RESET_PASSWORD_BY_EMAIL_FULFILLED = 'RESET_PASSWORD_BY_EMAIL_FULFILLED'
export const RESET_PASSWORD_BY_EMAIL_REJECTED = 'RESET_PASSWORD_BY_EMAIL_REJECTED'
export const resetPasswordByEmail = (payload = {}) => ({
  type: RESET_PASSWORD_BY_EMAIL,
  payload,
})

export const CONFIRM_FORGOT_PASSWORD = 'CONFIRM_FORGOT_PASSWORD'
export const CONFIRM_FORGOT_PASSWORD_FULFILLED = 'CONFIRM_FORGOT_PASSWORD_FULFILLED'
export const CONFIRM_FORGOT_PASSWORD_REJECTED = 'CONFIRM_FORGOT_PASSWORD_REJECTED'
export const confirmForgotPassword = (payload = {}) => ({
  type: CONFIRM_FORGOT_PASSWORD,
  payload,
})

export const CREATE_ACCOUNT = 'CREATE_ACCOUNT'
export const CREATE_ACCOUNT_FULFILLED = 'CREATE_ACCOUNT_FULFILLED'
export const CREATE_ACCOUNT_REJECTED = 'CREATE_ACCOUNT_REJECTED'
export const createAccount = (payload = {}) => ({type: CREATE_ACCOUNT, payload})

export const CREATE_RETAILER = 'CREATE_RETAILER'
export const CREATE_RETAILER_FULFILLED = 'CREATE_RETAILER_FULFILLED'
export const CREATE_RETAILER_REJECTED = 'CREATE_RETAILER_REJECTED'
export const createRetailer = (payload = {}) => ({type: CREATE_RETAILER, payload})

export const SET_URL_PARAMS = 'SET_URL_PARAMS'
export const SET_URL_PARAMS_FULFILLED = 'SET_URL_PARAMS_FULFILLED'
export const SET_URL_PARAMS_REJECTED = 'SET_URL_PARAMS_REJECTED'
export const setUrlParams = (payload = {}) => ({type: SET_URL_PARAMS, payload})

export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const setCurrentUser = (payload = {}) => ({type: SET_CURRENT_USER, payload})

export const HYDRATE_CURRENT_USER = 'HYDRATE_CURRENT_USER'
export const hydrateCurrentUser = (payload = {}) => ({type: HYDRATE_CURRENT_USER, payload})

export const MANUALLY_SET_JWT_FROM_COOKIE = 'MANUALLY_SET_JWT_FROM_COOKIE'
export const manuallySetJWTFromCookie = (payload = {}) => ({type: MANUALLY_SET_JWT_FROM_COOKIE, payload})

export const SAVE_RETAILER = 'SAVE_RETAILER'
export const SAVE_RETAILER_FULFILLED = 'SAVE_RETAILER_FULFILLED'
export const SAVE_RETAILER_REJECTED = 'SAVE_RETAILER_REJECTED'
export const saveRetailer = (payload = {}) => ({type: SAVE_RETAILER, payload})

export const ACCEPT_INVITE = 'ACCEPT_INVITE'
export const ACCEPT_INVITE_FULFILLED = 'ACCEPT_INVITE_FULFILLED'
export const ACCEPT_INVITE_REJECTED = 'ACCEPT_INVITE_REJECTED'
export const acceptInvite = (payload = {}) => ({type: ACCEPT_INVITE, payload})

export const UPDATE_PINPOINT_ENDPOINT = 'UPDATE_PINPOINT_ENDPOINT'
export const UPDATE_PINPOINT_ENDPOINT_FULFILLED = 'UPDATE_PINPOINT_ENDPOINT_FULFILLED'
export const UPDATE_PINPOINT_ENDPOINT_REJECTED = 'UPDATE_PINPOINT_ENDPOINT_REJECTED'
export const updatePinpointEndpoint = (payload = {}) => ({type: UPDATE_PINPOINT_ENDPOINT, payload})

export const RESET_STATE = 'RESET_STATE'
export const resetState = () => ({type: RESET_STATE})

export const LOGIN_ERROR = 'LOGIN_ERROR'

export const SET_SPINNER_ON = 'SET_SPINNER_ON'

export const ANALYTICS_TRACKING = 'ANALYTICS_TRACKING'
export const ANALYTICS_TRACKING_SUCCESS = 'ANALYTICS_TRACKING_SUCCESS'

export const CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING = 'CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING'
export const CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING_SUCCESS = 'CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING_SUCCESS'
export const CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING_ERROR = 'CREATE_RETAILER_HUBSPOT_ANALYTICS_TRACKING_ERROR'

export const CREATE_USER_HUBSPOT_ANALYTICS_TRACKING = 'CREATE_USER_HUBSPOT_ANALYTICS_TRACKING'
export const CREATE_USER_HUBSPOT_ANALYTICS_TRACKING_SUCCESS = 'CREATE_USER_HUBSPOT_ANALYTICS_TRACKING_SUCCESS'
export const CREATE_USER_HUBSPOT_ANALYTICS_TRACKING_ERROR = 'CREATE_USER_HUBSPOT_ANALYTICS_TRACKING_ERROR'
